import { ChangeEvent, useMemo, useState } from 'react';
import useInviteUserModalStore from 'store/useInviteUserModalStore';
import usePeopleQuery from '../queries/usePeopleQuery';
import usePeopleFilters from './usePeopleFilters';

export const usePeople = () => {
  const { people, isLoading } = usePeopleQuery();
  const [sortOpen, setSortOpen] = useState(false);
  const [sortBy, setSortBy] = useState(1);
  const openInviteUserModal = useInviteUserModalStore((state) => state.openModal);
  const sortByList = [
    { label: 'Alphabetical (A-Z)', value: 1 },
    { label: 'Alphabetical (Z-A)', value: -1 },
  ];
  const { filters, isFiltersLoading, clearFilters, setFilters } = usePeopleFilters({ people });

  const currentLabel = useMemo(() => {
    return sortByList.find((item) => item.value === sortBy)?.label;
  }, [sortBy, sortByList]);

  const peopleData = useMemo(() => {
    return people
      .filter((user) => {
        return filters.every((filter) => {
          const value = user[filter.category] || '(blank)';
          const selectedOptions =
            filter.inputType === 'radio' ? [filter.selectedValue] : filter?.selectedOptions || [];

          return (
            !selectedOptions.length ||
            (Array.isArray(value)
              ? selectedOptions.some((option) => value.includes(option))
              : selectedOptions.includes(value))
          );
        });
      })
      .sort((n1, n2) => {
        const a = n1.userNameToDisplay;
        const b = n2.userNameToDisplay;
        if (a > b) {
          return 1 * sortBy;
        }

        if (a < b) {
          return -1 * sortBy;
        }

        return 0;
      });
  }, [people, filters, sortBy]);

  const sortByHandler = (event: ChangeEvent<HTMLInputElement>) => {
    setSortBy(Number(event.target.value));
    setSortOpen(false);
  };

  return {
    currentLabel,
    filters,
    isFiltersLoading,
    isLoading,
    people,
    peopleData,
    sortBy,
    sortByList,
    sortOpen,
    clearFilters,
    openInviteUserModal,
    setFilters,
    setSortOpen,
    sortByHandler,
  };
};
